<template>
  <v-container class="rounded-xxl bg-background elevation-2">
    <v-row>
      <v-col cols="12" xl="6" class="d-flex align-center">
        <v-img v-if="img" :src="img" max-height="350" />
      </v-col>
      <v-col cols="12" xl="6" class="px-3 px-sm-16 pb-10">
        <h3>{{ title }}</h3>
        <v-list v-if="specs?.length > 0" class="bg-background">
          <v-list-item v-for="spec in specs" :key="spec" class="px-0" density="compact">
            • <span class="ms-3">{{ spec }}</span>
          </v-list-item>
        </v-list>
        <v-divider v-if="specs?.length > 0" class="mb-5" />
        <div class="d-flex align-center ga-1">
          <y-btn
            icon="mdi-minus"
            color="black"
            size="small"
            variant="text"
            :disabled="count <= 0"
            @click="count--"
          />
          <y-text-field v-model.number="count" class="text-center" hide-details />
          <y-btn
            icon="mdi-plus"
            color="black"
            size="small"
            variant="text"
            :disabled="count >= maxValue"
            @click="count++"
          />
        </div>
        <v-fade-transition>
          <div v-if="count > 0 && hasDocks">
            <v-divider class="my-5" />
            <p class="text-body-2">
              {{ t("components.devices.basket.docks.title") }}
            </p>
            <div class="d-flex align-center ga-1 mt-4">
              <y-btn
                icon="mdi-minus"
                color="black"
                size="small"
                variant="text"
                :disabled="docksCount <= 0"
                @click="docksCount--"
              />
              <y-text-field v-model.number="docksCount" class="text-center" hide-details />
              <y-btn
                icon="mdi-plus"
                color="black"
                size="small"
                variant="text"
                :disabled="docksCount >= maxValue"
                @click="docksCount++"
              />
            </div>
          </div>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const count = defineModel<number>("count", { default: 0 });
const docksCount = defineModel<number>("docksCount", { default: 0 });

defineProps({
  title: {
    type: String,
    required: true,
  },
  img: {
    type: String,
    default: undefined,
  },
  maxValue: {
    type: Number,
    default: 100,
  },
  hasDocks: {
    type: Boolean,
    default: false,
  },
  specs: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});
</script>

<style scoped>
.v-text-field.text-center :deep(input) {
  text-align: center;
}
</style>
